import { StockKind } from '../models/StockLine';

export default function getKindOptions(intl, withDefault = true) {
  return [
    ...(withDefault
      ? [{ value: '-', label: intl.formatMessage({ id: 'stock.all' }) }]
      : []),
    { value: StockKind.MIN, label: intl.formatMessage({ id: 'stock.min' }) },
    { value: StockKind.MAX, label: intl.formatMessage({ id: 'stock.max' }) },
    {
      value: StockKind.THRESHOLD,
      label: intl.formatMessage({ id: 'stock.threshold' }),
    },
    { value: StockKind.REAL, label: intl.formatMessage({ id: 'stock.real' }) },
    {
      value: StockKind.PENDING_TO_RECEIVE,
      label: intl.formatMessage({ id: 'stock.pendingToReceive' }),
    },
    {
      value: StockKind.RESERVED,
      label: intl.formatMessage({ id: 'stock.reserved' }),
    },
  ];
}
